import { WiskiStation } from '../../defs/WiskiTypes';

/**
 * Build a new URL by replacing the station id and station name (or longname)
 * while preserving the rest of the path and query string.
 *
 * @param {string} currentPath - The full current URL (which might include a hash).
 * @param {WiskiStation} to - Object with station_id and station_name or station_longname.
 * @returns {string} - The updated URL.
 */
export function buildStationUrl(currentPath: string, to: WiskiStation) {
  const hashIndex = currentPath.indexOf('#');
  let prefix = '';
  let route = currentPath;
  if (hashIndex !== -1) {
    // Keep everything up to and including the "#"
    prefix = currentPath.substring(0, hashIndex + 1);
    route = currentPath.substring(hashIndex + 1);
  }

  // Split the route into segments.
  const segments = route.split('/');
  const stationIndex = segments.findIndex(segment => segment === 'station');

  if (stationIndex === -1) {
    throw new Error('No station segment found in the route');
  }

  // Replace the station id and station name.
  segments[stationIndex + 1] = String(to.station_id);
  // Use station_name if provided, otherwise station_longname; encode to handle special chars.
  const name = to.station_name ?? to.station_longname;
  if (name) segments[stationIndex + 2] = encodeURIComponent(name);
  else
    throw Error(
      'Name not found in URL, station_name or station_longname must be defined',
    );

  // Reassemble the route and add back the prefix.
  return prefix + segments.join('/');
}
